<template>
  <div class="not-found z-i-5">
    <img src="@/assets/images/404-image.svg" />
    <h1 class="not-found__title">Error: Page not found</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped lang="scss">
.not-found {
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: $primary-color;

  img {
    max-width: calc(100% - 120px);
  }

  &__title {
    margin-top: 40px;
    font-family: $fontFamilyPrimary;
    font-weight: $font_bold;
    color: $not-found-color;
    text-align: center;
  }
}
</style>
